import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LogoDevIcon(props: IconProps) {
    return <Icon {...props} iconKey={"logo_dev"}/>
}
